import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddAirwayToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/airway/store/airway.actions'
import { addAirwayItem } from '../../timeline/store/timeline.actions'
import { AirwayConstants } from '../../procedures/airway/store/airway.constants'

export function* saveAirwayQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addAirwayToTimeline } = quickActionsObject
  if (addAirwayToTimeline) {
    yield put(addAirwayItem())
    yield put(setAddAirwayToTimeline(false))
    yield put(resetState())
  }
}

export function* saveAirwayQuickActionTimeLineRowSaga() {
  yield takeLatest([AirwayConstants.SET_ADD_TO_TIMELINE], saveAirwayQuickActionTimeLineRow)
}
